import * as WebBrowser from 'expo-web-browser';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { useDynamicStyles } from '../hooks';
import { Button, ButtonVariants } from './Button';
import { Modal } from './Modal';
import { TextBold, TextReg } from './StyledText';

type Props = {
  visible: boolean;
  onClose: () => void;
  eventId?: string;
};

export function FirstVoteCelebrationModal({
  visible,
  onClose,
  eventId,
}: Props) {
  const styles = useDynamicStyles(createStyles);

  const handleTicketsPress = async () => {
    // Don't close the modal - let it persist when user returns from browser
    if (eventId) {
      await WebBrowser.openBrowserAsync(
        `https://checkout.joincommuniful.com/events/${eventId}`,
        {
          windowFeatures: {
            popup: false,
          },
        },
      );
    }
  };

  return (
    <Modal
      visible={visible}
      hide={onClose}
      fullscreenOnBreakpoint={false}
      size="small"
      modalStyle={styles.modal}
      contentStyle={styles.content}
    >
      <View style={styles.celebration}>
        <TextBold style={styles.emoji}>🎉</TextBold>
        <TextBold style={styles.title}>Congratulations!</TextBold>
        <TextReg style={styles.subtitle}>
          You cast your first vote! Your voice helps shape the schedule.
        </TextReg>
      </View>

      {eventId && (
        <View style={styles.buttonContainer}>
          <Button
            mode="contained"
            variant={ButtonVariants.PURPLE}
            onPress={handleTicketsPress}
            style={styles.ticketsButton}
          >
            Get Tickets
          </Button>
        </View>
      )}
    </Modal>
  );
}

const createStyles = () =>
  StyleSheet.create({
    modal: {
      marginLeft: 'auto',
      borderRadius: 16,
      paddingTop: 0,
    },
    content: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    celebration: {
      alignItems: 'center',
      marginBottom: 32,
    },
    emoji: {
      fontSize: 64,
      marginBottom: 16,
    },
    title: {
      fontSize: 24,
      marginBottom: 12,
      textAlign: 'center',
    },
    subtitle: {
      fontSize: 16,
      textAlign: 'center',
      lineHeight: 22,
      marginBottom: 8,
    },
    buttonContainer: {
      width: '100%',
    },
    ticketsButton: {
      width: '100%',
    },
  });
